import { useEffect, useMemo, useState } from "react"

import { Input, InputGroup, InputGroupText, Select } from "twyne-new.ui"

import { UNIT_OPTIONS } from "../../utils/predefined_sizes"
import ColorPickerProperty from "../Color"

import { useFilters } from "./context"

export default function FilterDropShadow({ type }) {
  const [unit, setUnit] = useState()

  const { handleChange, filters } = useFilters()
  const { value, color } = useMemo(() => filters?.[type]?.['drop-shadow'] || {}, [filters, type])
  const isArbitrary = useMemo(() => value && typeof value !== 'string', [value])

  useEffect(() => {
    if (unit === undefined) {
      setUnit(!isArbitrary ? 'px' : value?.x?.split('_')[1] || 'px')
    }
  }, [unit, isArbitrary, value])

  const handleChangeDropShadow = ({ newValue, key }) => {
    handleChange({ type, key: 'drop-shadow', value: { color, value, [key]: newValue } })
  }

  const handleChangeValue = newValue => {
    if (newValue === 'arbitrary' && !isArbitrary) {
      return handleChangeDropShadow({ newValue: {}, key: 'value' })
    }

    handleChangeDropShadow({ newValue, key: 'value' })
  }

  const handleChangeUnit = newUnit => {
    let { x = '', y = '', blur = '' } = value
    x = [x.split('_')[0], newUnit].join('_')
    y = [y.split('_')[0], newUnit].join('_')
    blur = [blur.split('_')[0], newUnit].join('_')
    handleChangeDropShadow({ newValue: { x, y, blur }, key: 'value' })
    setUnit(newUnit)
  }

  return <>
    <div className="flex flex-col gap-2">

      <div className="w-full flex flex-col gap-1 items-center">
        <div className='w-full flex gap-1 items-center'>
          <Select
            value={isArbitrary ? 'arbitrary' : value}
            onChange={option => handleChangeValue(option?.value)}
            options={[{ label: 'Arbitrary', value: 'arbitrary' }, ...PREDEFINED_OPTIONS]}
            clearable
          />
          {isArbitrary && <Select
            options={UNIT_OPTIONS}
            value={unit}
            onChange={option => handleChangeUnit(option?.value)}
            placeholder='Unit'
            variant='accent'
          />}
        </div>
        {isArbitrary && <ArbitraryInputs unit={unit} value={value} onChange={handleChangeValue} />}
      </div>

      <ColorPickerProperty
        value={color}
        onChange={color => handleChangeDropShadow({ newValue: color, key: 'color' })}
      />
    </div>
  </>
}

const ArbitraryInputs = ({ unit, value, onChange }) => {
  const { x, y, blur } = value

  const getValue = (value = '') => value.split('_')[0]

  const handleChange = (key, newValue) => {
    onChange({ ...value, [key]: newValue ? [newValue, unit].join('_') : '' })
  }

  return <div className='w-full flex flex-col gap-1'>
    <div className='flex gap-1 items-center'>
      <InputGroup className='w-full'>
        <InputGroupText>
          <div className='w-[23px] text-center'>
            X
          </div>
        </InputGroupText>
        <Input type='number' value={getValue(x)} onChange={e => handleChange('x', e.target.value)} />
      </InputGroup>
      <InputGroup className='w-full'>
        <InputGroupText>
          <div className='w-[23px] text-center'>
            Y
          </div>
        </InputGroupText>
        <Input type='number' value={getValue(y)} onChange={e => handleChange('y', e.target.value)} />
      </InputGroup>
    </div>
    <InputGroup className='w-full'>
      <InputGroupText className='w-10'>
        <div className='w-8 text-center'>
          Blur
        </div>
      </InputGroupText>
      <Input type='number' value={getValue(blur)} onChange={e => handleChange('blur', e.target.value)} />
    </InputGroup>
  </div>
}

const PREDEFINED_OPTIONS = [
  { label: 'Extra small', value: 'xs' },
  { label: 'Small', value: 'sm' },
  { label: 'Medium', value: 'md' },
  { label: 'Large', value: 'lg' },
  { label: 'Extra large', value: 'xl' },
  { label: '2 Extra large', value: '2xl' },
  { label: 'None', value: 'none' },
]
